import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=63263cde&"
import script from "./Loader.vue?vue&type=script&lang=js&"
export * from "./Loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63263cde')) {
      api.createRecord('63263cde', component.options)
    } else {
      api.reload('63263cde', component.options)
    }
    module.hot.accept("./Loader.vue?vue&type=template&id=63263cde&", function () {
      api.rerender('63263cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/Loader.vue"
export default component.exports